var HSForm_AddressHelpers = new Object();

HSForm_AddressHelpers.version = "1.0.0";
HSForm_AddressHelpers.$form = null;

HSForm_AddressHelpers.init = function ($form) {
  this.$form = $form;
  let address_id = $form.find('input[name="full_address"]').attr("id");
  let address_input = document.getElementById(address_id);

  // Create the autocomplete object, restricting the search predictions to
  // addresses in the US and Canada.
  var autocomplete;
  autocomplete = new google.maps.places.Autocomplete(address_input, {
    componentRestrictions: { country: [thryvSettings.thryvCountry] },
    fields: ["address_components", "geometry"],
    types: ["address"],
  });

  if (helpers.shouldDebug("hsForm"))
    console.log("[HSForm.AddressHelpers] autocomplete:", autocomplete);

  var referral_address = [];
  const fillInAddress = function () {
    if (helpers.shouldDebug("hsForm"))
      console.log("[HSForm.AddressHelpers] autocomplete:", autocomplete);
    // Get the place details from the autocomplete object.
    const place = autocomplete.getPlace();
    let address1 = "";
    let postcode = "";
    if (helpers.shouldDebug("hsForm")) console.log("[HSForm.AddressHelpers] place:", place);

    if (helpers.shouldDebug("hsForm"))
      console.log("[HSForm.AddressHelpers] referral_address:", referral_address);

    // Get each component of the address from the place details,
    // and then fill-in the corresponding field on the form.
    // place.address_components are google.maps.GeocoderAddressComponent objects
    // which are documented at http://goo.gle/3l5i5Mr
    for (const component of place.address_components) {
      // @ts-ignore remove once typings fixed
      const componentType = component.types[0];

      // console.log(componentType + ':', component);

      switch (componentType) {
        case "street_number": {
          address1 = `${component.long_name} ${address1}`;
          referral_address["street_address"] = address1;
          break;
        }

        case "route": {
          address1 += component.short_name;
          referral_address["street_address"] = address1;
          break;
        }

        case "postal_code": {
          postcode = `${component.long_name}${postcode}`;
          referral_address["zip"] = postcode;
          break;
        }

        case "postal_code_suffix": {
          postcode = `${postcode}-${component.long_name}`;
          referral_address["zip"] = postcode;
          break;
        }

        case "locality":
          referral_address["city"] = component.long_name;
          break;
        case "administrative_area_level_1": {
          referral_address["state"] = component.short_name;
          break;
        }
        case "country":
          referral_address["country"] = component.long_name;
          break;
      }
    }

    if (helpers.shouldDebug("hsForm"))
      console.log("[HSForm.AddressHelpers] final referral_address:", referral_address);
    HSForm_AddressHelpers.updateFields(referral_address, $form);
  };

  // When the user selects an address from the drop-down, populate the
  // address fields in the form.
  autocomplete.addListener("place_changed", fillInAddress);
};

HSForm_AddressHelpers.updateFields = function (referral_address, $form) {
  $form.find('input[name="address"]').val(referral_address?.street_address);
  $form.find('input[name="city"]').val(referral_address?.city);
  $form.find('input[name="state"]').val(referral_address?.state);
  $form.find('input[name="zip"]').val(referral_address?.zip);
  $form.find('input[name="country"]').val(referral_address?.country);
};

export default HSForm_AddressHelpers;
